// extracted by mini-css-extract-plugin
export default {"tabs":"tabs---equMR","tab":"tab---nrcz3","active":"active---ZHMBD","badge":"badge---aVftX"};